module.exports = __webpack_public_path__ + "img/image_aoi-984359f3.png";